export var MODAL_Z_INDEX = 2000;
export var BACKDROP_Z_INDEX = 1500;
export var BASE_Z_INDEX = 0;
export var NEGATIVE_BASE_Z_INDEX = -1;
